module.exports = __webpack_public_path__ + "media/images/page/gift-flow03-d89fc38b95fce745da6e760a4286f51b.jpg";